import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../httpClient/httpClient.service';
import { boardApis } from '../../constants/board-name-api';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { permissionEntity } from '../../constants/permission';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { specificUserParams, userParams } from '../../helpers/helperfunc';

@Injectable({
  providedIn: 'root'
})
export class BoardNameService {
  permissions_entity = permissionEntity;
 
  constructor(
    private httpClientService: HttpClientService,
    private _permissionPipe: PermissionsPipe // dont remove this
  ) {}

  getBoardList(pagination: PaginationType, filters?: any, search?: string, sort: {sortDataOption:string, sortDataOrder:string} = null): Observable<any> {
    let query = '?';
    if (filters) {
        query += filters;
    }
    if (search) {
      query += `search=${search}&`;
    }
    if (sort) {
      query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
    }
    query += userParams.call(this, this.permissions_entity.modules.board);
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;

    return this.httpClientService.get(`${boardApis.getboardList}${query}`);
  }
  getBoardListV2(): Observable<any> {
    return this.httpClientService.get(`${boardApis.getboardListV2}`);
  }

  getBoardBySearchDuplicate(pagination: PaginationType, filters?: any, search?: string, degreeTypeId?:any, sort: {sortDataOption:string, sortDataOrder:string} = null): Observable<any> {
    let query = '?';
    if (filters) {
        query += filters;
    }
    if (search) {
      query += `search=${search}&`;
    }
    if (degreeTypeId) {
      query += `degreeType=${degreeTypeId}&`;
    }
    if (sort) {
      query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
    }
    query += userParams.call(this, this.permissions_entity.modules.board);
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;

    return this.httpClientService.get(`${boardApis.getboardLists}${query}`);
  }

  getBoardByDtypeStateId(params: any, pagination: any, search?: string): Observable<any> {
    let query = '?';

    if (params) {
      query += `degreeType=${params.degreeType}&status=true&stateId=${params.stateId}&`;
    }
    if (search) {
      query += `search=${search}&`;
    }
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.get(`${boardApis.getboardList}${query}`);
  }

  getEnglishBoard(degreeType: any, pagination: any): Observable<any> {
    return this.httpClientService.get(`${boardApis.getboardList}?degreeType=${degreeType}&skip=${pagination.skip}&limit=${pagination.limit}`);
  }

  getBoardById(id: string): Observable<any> {
      return this.httpClientService.get(`${boardApis.getboardbyId}${id}`);
  }

  createBoard(payload: unknown): Observable<any> {
      return this.httpClientService.post(boardApis.createboard, payload);
  }

  updateBoard(id: string, payload: unknown): Observable<any> {
      return this.httpClientService.put(boardApis.updateboardById.replace(':boardID', id), payload);
  }

  // deleteBoard(id: string): Observable<any> {
  //     return this.httpClientService.delete(boardApis.deleteboardbyId.replace(':boardID', id));
  // }
  updateBoardStatus(id: string): Observable<any> {
    return this.httpClientService.put(`${boardApis.updateboardbyId}${id}`, {});
  }

  getBoardForRequirements(stateId: any, degreeType?): Observable<any> {
    let query = '?';
    if (stateId) {
      query += `stateId=${stateId}&`;
    }
    if (degreeType) {
      query += `degreeType=${degreeType}&`;
    }
    query += `skip=0&limit=5000`;
    return this.httpClientService.get(`${boardApis.getboardList}${query}`);
  }

  getBoardByCountry(params: any, pagination: any, search?: string): Observable<any> {
    let query = '?';

    if (params) {
      query += `status=true&degreeType=${params.degreeType}&countryId=${params.country}&`;
    }
    if (search) {
      query += `search=${search}&`;
    }
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.get(`${boardApis.getboardList}${query}`);
  }

  getBoardListName( pagination: any, search?: string): Observable<any> {
    let query = '?';
    if (search) {
      query += `search=${search}&`;
    }
    query += `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.get(`${boardApis.getboardList}${query}`);
  }
}
